export async function useCurrentBiennaleEvent(opts = {}) {
  const { data: currentEventData, pending } = await usePersistedFetch('GetBiennalesPaginated', { first: 1, page: 1 }, opts);

  const currentEvent = computed(() => {
    const events = currentEventData.value?.biennalesPaginated?.data;
    if (!events || events.length === 0) return null;
    return events[0];
  });

  return { currentEvent, pending };
}
